import { useEffect, useState } from "react";
import Modal from "../../components/modal/modal.component";
import InputComponent from "../../components/input/input.component";
import SelectComponent from "../../components/select/select.component";
import DatepickerComponent from "../../components/datepicker/datepicker.component";
import { Controller, useForm } from "react-hook-form";
import TextareaComponent from "../../components/textarea/textarea.component";
import { PartnerAccountsService } from "../../services/operation/partner-accounts";
import { PartnersService } from "../../services/partners";
import Button from "../../components/button/button.component";
import { to } from "../../polyfill";
import usePeriod from "../../hooks/period.use";
import AlertPeriod from "../../components/alert-period/alert-period";
import InvalidFeedback from "../../components/invalid-feedback/invalid-feedback.component";
import { UtilsService } from "../../services/utils";

function FormModal({ show, data, setShow }: any) {
  const { currentPeriod } = usePeriod();

  const [partners, setPartners] = useState<any[]>([]);

  const defaultValues = {
    _id: "",
    period: currentPeriod._id,
    partner: "",
    date: "",
    type: "",
    amount: 0,
    comments: "",
  };

  const {
    watch,
    setValue,
    reset,
    control,
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isValid },
  } = useForm<typeof defaultValues>({
    mode: "onChange",
    defaultValues,
  });

  const _id = watch("_id");

  const submit = async (form: typeof defaultValues) => {
    const [error, data] = await to(PartnerAccountsService.save(form));
    if (error) {
      alert(error.message);
    } else {
      setShow(true);
      reset(defaultValues);
    }
  };

  const getPartners = async () => {
    const data = await PartnersService.list();
    setPartners(data.filter((d: any) => d.status));
  };

  useEffect(() => {
    getPartners();
  }, []);

  useEffect(() => {
    setValue("partner", "");
  }, [partners]);

  useEffect(() => {
    if (data) {
      reset({
        _id: data._id,
        period: currentPeriod._id,
        partner: data.partner._id,
        date: UtilsService.dateFormat(data.date, "YYYY-MM-DD"),
        type: data.type,
        amount: data.amount,
        comments: data.comments,
      });
    }

    if(!show) {
      reset(defaultValues);
    }
  }, [data, show]);

  return (
    <Modal show={show}>
      <div className="modal-header">
        <h3 className="modal-title">
          {!_id ? "Agregar" : "Editar"} cuenta de socios y colaboradores
        </h3>
        <div
          className="btn btn-icon btn-sm btn-active-light-primary ms-2"
          onClick={setShow}
        >
          <i className="ki-duotone ki-cross fs-1">
            <span className="path1" />
            <span className="path2" />
          </i>
        </div>
      </div>
      <div className="modal-body">
        <div className="mb-5">
          <AlertPeriod />
        </div>

        <div className="mb-5">
          <SelectComponent
            label="Socio *"
            data={partners.map((row) => ({ value: row._id, text: row.name }))}
            {...register("partner", { required: true })}
            errors={errors.partner}
          />
        </div>

        <div className="mb-5">
          <Controller
            name="date"
            control={control}
            rules={{ required: true }}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <>
                <DatepickerComponent
                  label="Fecha *"
                  errors={error}
                  onChange={onChange}
                  value={value}
                />
                <InvalidFeedback error={error} />
              </>
            )}
          />
        </div>

        <div className="mb-5">
          <SelectComponent
            label="Tipo  *"
            data={[
              {
                value: "ingreso",
                text: "Ingreso (aportaciones a la empresa, paga el socio)",
              },
              {
                value: "egreso",
                text: "Egreso (la empresa paga)",
              },
            ]}
            {...register("type", { required: true })}
            errors={errors.type}
          />
        </div>

        <div className="mb-5">
          <InputComponent
            label="Monto *"
            {...register("amount", { required: true, pattern: {
              value: /^\d+(\.\d{1,2})?$/,
              message:
                "Solo se permiten números y un máximo de dos decimales",
            }, })}
            errors={errors.amount}
          />
        </div>

        <div className="mb-5">
          <TextareaComponent
            label="Concepto *"
            {...register("comments", { required: true })}
            errors={errors.comments}
          />
        </div>
      </div>
      <div className="modal-footer">
        <button className="btn btn-light" type="button" onClick={setShow}>
          Cancelar
        </button>
        <Button
          className="btn btn-primary"
          disabled={!isValid}
          isLoading={isSubmitting}
          onClick={handleSubmit(submit)}
        >
          Guardar
        </Button>
      </div>
    </Modal>
  );
}

export default FormModal;
